import React, { useState, useEffect, useRef } from "react";
import ModalConnector from "../components/ModalConnector/ModalConnector";
import { Link } from "react-router-dom";

import useWindowDimensions from "../hooks/useWindowDimensions";
import { useTranslation } from "react-i18next";
import parse_html from "html-react-parser";

import "../styles/style.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, FreeMode, Keyboard, Mousewheel, EffectCards } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/effect-cards';
import Dropdown from "rc-dropdown";
import Menu, { Item as MenuItem } from "rc-menu";

import "rc-dropdown/assets/index.css";
import { useSelector } from "react-redux";
import AnimationBlock from "../blocks/AnimationBlock/AnimationBlock";
import { AnimationOnScroll } from 'react-animation-on-scroll';

export default function Landing(props) {
    const [isOpen, setIsOpen] = useState(false);

    const { height, width } = useWindowDimensions();

    const [showMenu, setShowMenu] = useState(false);
    const [burgerMenu, setBurgerMenu] = useState(false);

    const headerActive = showMenu ? "active" : "";
    const headerClasses = ["header_landing", headerActive];

    const burgerActive = showMenu ? "active" : "";
    const burgerClasses = ["burgerMenu", burgerActive];

    const { t, i18n } = useTranslation();

    useEffect(() => {
        document.body.classList.add('body-landing');
    }, []);

    const modalMenu = () => {
        setShowMenu((prev) => !prev);
        setBurgerMenu((prev) => !prev);
        document.querySelector("body").classList.toggle("overflowHidden");
    };

    const [contLocale, setContLocale] = useState("");

    function onSelect({ key }) {
        i18n.changeLanguage(key);
        setContLocale(key);
        // console.log(key);
    }

    function onVisibleChange(visible) {
        // console.log(visible);
    }

    const menu = (
        <Menu onSelect={onSelect}>
            <MenuItem key="en">
                <a className="opHover" href="#">
                    <img src="img/flags/en.svg" alt="" />
                    <div className="lang">EN</div>
                </a>
            </MenuItem>
            <MenuItem key="uk">
                <a className="opHover" href="#">
                    <img src="img/flags/uk.svg" alt="" />
                    <div className="lang">UK</div>
                </a>
            </MenuItem>
            <MenuItem key="es">
                <a className="opHover" href="#">
                    <img src="img/flags/es.svg" alt="" />
                    <div className="lang">ES</div>
                </a>
            </MenuItem>
            <MenuItem key="it">
                <a className="opHover" href="#">
                    <img src="img/flags/it.svg" alt="" />
                    <div className="lang">IT</div>
                </a>
            </MenuItem>
            <MenuItem key="pt">
                <a className="opHover" href="#">
                    <img src="img/flags/pt.svg" alt="" />
                    <div className="lang">PT</div>
                </a>
            </MenuItem>
            <MenuItem key="fr">
                <a className="opHover" href="#">
                    <img src="img/flags/fr.svg" alt="" />
                    <div className="lang">FR</div>
                </a>
            </MenuItem>
            <MenuItem key="hu">
                <a className="opHover" href="#">
                    <img src="img/flags/hu.svg" alt="" />
                    <div className="lang">HU</div>
                </a>
            </MenuItem>
            <MenuItem key="de">
                <a className="opHover" href="#">
                    <img src="img/flags/de.svg" alt="" />
                    <div className="lang">DE</div>
                </a>
            </MenuItem>
            <MenuItem key="vi">
                <a className="opHover" href="#">
                    <img src="img/flags/vi.svg" alt="" />
                    <div className="lang">VI</div>
                </a>
            </MenuItem>
            <MenuItem key="tr">
                <a className="opHover" href="#">
                    <img src="img/flags/tr.svg" alt="" />
                    <div className="lang">TR</div>
                </a>
            </MenuItem>
            <MenuItem key="id">
                <a className="opHover" href="#">
                    <img src="img/flags/id.svg" alt="" />
                    <div className="lang">ID</div>
                </a>
            </MenuItem>
            <MenuItem key="zh">
                <a className="opHover" href="#">
                    <img src="img/flags/zh.svg" alt="" />
                    <div className="lang">ZH</div>
                </a>
            </MenuItem>
            <MenuItem key="kr">
                <a className="opHover" href="#">
                    <img src="img/flags/kr.svg" alt="" />
                    <div className="lang">KR</div>
                </a>
            </MenuItem>
            <MenuItem key="jp">
                <a className="opHover" href="#">
                    <img src="img/flags/jp.svg" alt="" />
                    <div className="lang">JP</div>
                </a>
            </MenuItem>
            <MenuItem key="pl">
                <a className="opHover" href="#">
                    <img src="img/flags/pl.jpg" alt="" />
                    <div className="lang">PL</div>
                </a>
            </MenuItem>
            <MenuItem key="ru">
                <a className="opHover" href="#">
                    <img src="img/flags/ru.svg" alt="" />
                    <div className="lang">RU</div>
                </a>
            </MenuItem>
        </Menu>
    );

    let currentLanguage = i18n.language.split("-");
    currentLanguage = currentLanguage[0]

    const MainVideoStart = (e) => {
        console.log('this');
        console.log(e.target.scrollHeight);
        console.log(e.target.scrollTop);
        console.log(e.target.scrollHeight - e.target.scrollTop);
    }

    return (
        <>
            <div className="wrapper" onScroll={MainVideoStart}>
                <div class="bg-animate">
                    <div class="bg-animate-holder">
                        <div class="bg-animate__block"></div>
                        <div class="bg-animate__block"></div>
                        <div class="bg-animate__block"></div>
                        <div class="bg-animate__block"></div>
                    </div>
                </div>
                    <header className="landing_header">
                        <div className="container">
                            <div className="header_wrapper">
                                <div className="logo"><img src="/images/logo.png" /></div>
                                <div className="topmenu">
                                    <ul>
                                        <li><a href="#">Home</a></li>
                                        <li><a href="#about">About project</a></li>
                                        <li><a href="#howto">How to start</a></li>
                                    </ul>
                                </div>
                                <div className="wallet">
                                    {props.loading === true ? (
                                        <a
                                            className="opHover"
                                            href="#"
                                            onClick={() => {
                                                setIsOpen(true);
                                            }}
                                        >
                                            <div className="connectButton">
                                                Connect Wallet
                                            </div>                                                                
                                        </a>
                                    ) : (
                                        <Link
                                            className="opHover"
                                            to="/dashboard"
                                        >
                                            <div className="connectButton --active">
                                                Dashboard
                                            </div> 
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    </header>
                    <main className="page">
                        <section className="firstBlock">
                            <div className="container">
                                <div className="firstBlockText">
                                <AnimationOnScroll animateIn="animate__fadeInUp">
                                    <h1>Start winning<span>in Bayon</span></h1>
                                </AnimationOnScroll>
                                <AnimationOnScroll animateIn="animate__fadeInUp">
                                    <div className="firstBlockExplain">
                                        <p>The Bayon concept is really simple to understand</p>
                                        <img src="/images/appstore.png" className="storeIcon" />
                                        <img src="/images/googleplay.png" className="storeIcon" />
                                    </div>
                                </AnimationOnScroll>
                                </div>
                                <div className="hero-img-holder">
                                    <img src="/images/phone1.png" className="phoneOneImg" />
                                    <img src="/images/phone2.png" className="phoneTwoImg" />
                                    <img src="/images/plant1.png" className="plantOneImg" />
                                    <img src="/images/plant2.png" className="plantTwoImg" />
                                    <img src="/images/plant3.png" className="plantThreeImg" />
                                </div>
                            </div>
                        </section>
                        <section id="slider" className="screenshotBlock">
                        <AnimationOnScroll animateIn="animate__fadeInUp">
                            <h1 className="text-center mb-3">OUR READY-MADE SOLUTION<br/> TO CRYPTO-TRADING</h1>
                        </AnimationOnScroll>
                            <p className="text-center mb-5">
                                {props.loading === true ? (
                                        <a
                                            className="btn btn-orange"
                                            href="#"
                                            onClick={() => {
                                                setIsOpen(true);
                                            }}
                                        >
                                                Connect Wallet                                                  
                                        </a>
                                    ) : (
                                        <Link
                                            className="btn btn-orange"
                                            to="/dashboard"
                                        >
                                                Dashboard
                                        </Link>
                                    )}
                            </p>
                            <Swiper
                            /*loop={false}
                            speed={1000}*/
                            effect={'cards'}
                            grabCursor={true}
                            modules={[
                                /*Navigation,
                                Pagination,
                                FreeMode,*/
                                EffectCards
                            ]}
                            /*navigation={{
                                nextEl: ".swiperMiniNavigationNext",
                                prevEl: ".swiperMiniNavigationPrev",
                                clickable: true,
                            }}*/
                            /*freeMode={false}
                            keyboard={false}
                            slidesPerView={'auto'}
                            spaceBetween={20}
                            scrollbar={{ el: ".swiper-scrollbar", draggable: true }}
                            pagination={{
                                clickable: true,
                            }}*/
                            //onSlideChange={() => setCurrentSwiperPage(swiper.activeIndex)}
                            //onSwiper={(swiper) => setSwiper(swiper)}
                            /*breakpoints={{
                                100: {
                                    slidesPerView: 'auto',
                                },
                                680: {
                                    slidesPerView: 'auto',
                                },
                                1200: {
                                    slidesPerView: 'auto',
                                },
                                1270: {
                                    slidesPerView: 'auto',
                                },
                                }}*/
                            >
                                <SwiperSlide>
                                    <div className="swiperSlide">
                                    <img src="/images/screen1.png" className="screenImage" />
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="swiperSlide">
                                    <img src="/images/screen2.png" className="screenImage" />
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="swiperSlide">
                                    <img src="/images/screen3.png" className="screenImage" />
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="swiperSlide">
                                    <img src="/images/screen4.png" className="screenImage" />
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="swiperSlide">
                                    <img src="/images/screen5.png" className="screenImage" />
                                    </div>
                                </SwiperSlide>
                            </Swiper>
                        </section>
                        <section id="about" className="secondBlock">
                            <div className="container">
                                <div className="aboutBlock">
                                <AnimationOnScroll animateIn="animate__fadeInUp"><h1>About project</h1></AnimationOnScroll>
                                    <p>You can bet for bitcoin or other cryptocurrency price.</p>
                                    <p>
                                    {props.loading === true ? (
                                        <a
                                            className="btn btn-orange"
                                            href="#"
                                            onClick={() => {
                                                setIsOpen(true);
                                            }}
                                        >
                                                Connect Wallet                                                  
                                        </a>
                                    ) : (
                                        <Link
                                            className="btn btn-orange"
                                            to="/dashboard"
                                        >
                                                Dashboard
                                        </Link>
                                    )}
                                    </p>
                                    <div className="secondBlockImage">
                                        <img src="/images/aboutBg.png" />
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="why" className="secondWhyBlock">
                            <div className="container">
                            <AnimationOnScroll animateIn="animate__fadeInUp"><h1 className="text-center mb-3">WHY OUR TOKENS?</h1></AnimationOnScroll>
                                <div className="secondWhyBlockWrap">
                                    <div className="secondWhyBlockItem">
                                        <div className="row">
                                            <div class="col-12 col-md-6 d-flex align-items-center gap-10">
                                                <img src="/images/arrow-growth.svg" />
                                                <h3>Active Participation in Growth</h3>
                                            </div>
                                            <div class="col-12 col-md-6">
                                                <p>Bayon tokens offer a unique opportunity for active involvement in platform development. Users can create new tokens, directly contributing to the platform's expansion.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="secondWhyBlockItem">
                                        <div className="row">
                                            <div class="col-12 col-md-6 d-flex align-items-center gap-10">
                                                <img src="/images/circle-right.svg" />
                                                <h3>Stability and Control</h3>
                                            </div>
                                            <div class="col-12 col-md-6">
                                                <p>The platform implements strict limits on minting, collateral requirements, and dynamic adjustments based on market conditions. These measures aim to ensure token stability, preventing inflation, and maintaining a balanced ecosystem.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="secondWhyBlockItem">
                                        <div className="row">
                                            <div class="col-12 col-md-6 d-flex align-items-center gap-10">
                                                <img src="/images/arrow-forward.svg" />
                                                <h3>Incentives for Engagement</h3>
                                            </div>
                                            <div class="col-12 col-md-6">
                                                <p>Participants in the minting process receive rewards in the form of a percentage of newly minted tokens. This incentivizes ongoing engagement, considering collateral contribution and engagement history.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="secondWhyBlockItem">
                                        <div className="row">
                                            <div class="col-12 col-md-6 d-flex align-items-center gap-10">
                                                <img src="/images/cube-transparent.svg" />
                                                <h3>Security;<br />Compliance;<br />Transparency</h3>
                                            </div>
                                            <div class="col-12 col-md-6">
                                                <p>The minting process undergoes thorough security checks and verification steps, ensuring compliance with financial standards like AML and KYC. This emphasis on security, transparency, and legal compliance reflects Bayon's commitment to a trustworthy and legally compliant platform.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section id="bet" className="secondBetBlock mt-5">
                            <div className="container">
                        <AnimationOnScroll animateIn="animate__fadeInUp"><h1 className="mb-5">Why users should place<br /> the bets/predictions</h1></AnimationOnScroll>
                            <p className="mb-5">Bet or predict for the thrill of anticipation, the chance to apply insights, and the excitement of being part of a dynamic community. It's about engaging your instincts, learning from outcomes, and the rush of being a participant in an entertainment-meets-foresight world.</p>
                            <div>
                                {props.loading === true ? (
                                    <a
                                        className="btn btn-orange"
                                        href="#"
                                        onClick={() => {
                                            setIsOpen(true);
                                        }}
                                    >
                                            Connect Wallet                                                  
                                    </a>
                                ) : (
                                    <Link
                                        className="btn btn-orange"
                                        to="/dashboard"
                                    >
                                            Dashboard
                                    </Link>
                                )}                                
                            </div>
                            <div className="d-flex justify-content-end" style={{marginTop: "-40px"}}>
                                <img src="/images/betBg.png" className="betImage" />
                            </div>
                            </div>
                        </section>
                        <section id="howto" className="thirdBlock">
                            <div className="container">
                                <div className="d-flex justify-content-between align-items-center">
                                <AnimationOnScroll animateIn="animate__fadeInUp"><h1>How to start</h1></AnimationOnScroll>
                                    {props.loading === true ? (
                                        <a
                                            className="btn btn-orange"
                                            href="#"
                                            onClick={() => {
                                                setIsOpen(true);
                                            }}
                                        >
                                                Connect Wallet                                                  
                                        </a>
                                    ) : (
                                        <Link
                                            className="btn btn-orange"
                                            to="/dashboard"
                                        >
                                                Dashboard
                                        </Link>
                                    )}
                                </div>
                                
                                <div className="thirdBlockWrap">
                                    <div className="thirdBlockItem">
                                        <div className="thirdBlockNumber">01.</div>
                                        <div className="thirdBlockName">Download the application</div>
                                        <div className="thirdBlockDesc">Go to Google Play or Appstore for download an application.</div>
                                        <div className="thirdBlockImage"><img src="/images/how_one.png" className="howImage" /></div>
                                    </div>
                                    <div className="thirdBlockItem">
                                        <div className="thirdBlockNumber">02.</div>
                                        <div className="thirdBlockName">Connect your cryptowallet</div>
                                        <div className="thirdBlockDesc">Use Trust Wallet or different cryptowallet for connect to your wallet</div>
                                        <div className="thirdBlockImage"><img src="/images/how_two.png" className="howImage" /></div>
                                    </div>
                                    <div className="thirdBlockItem">
                                        <div className="thirdBlockNumber">03.</div>
                                        <div className="thirdBlockName">Place points</div>
                                        <div className="thirdBlockDesc">You can choose an cryptocurrency and place a bet for his price</div>
                                        <div className="thirdBlockImage"><img src="/images/how_three.png" className="howImage" /></div>
                                    </div>
                                </div>
                                <div className="thirdBlockButton">
                                    {props.loading === true ? (
                                        <a
                                            className="opHover"
                                            href="#"
                                            onClick={() => {
                                                setIsOpen(true);
                                            }}
                                        >
                                            <div className="connectButtonMore">
                                                Connect Wallet
                                            </div>                                                                
                                        </a>
                                    ) : (
                                        <Link
                                            className="opHover"
                                            to="/dashboard"
                                        >
                                            <div className="connectButtonMore --active">
                                                Dashboard
                                            </div> 
                                        </Link>
                                    )}                                    
                                </div>
                            </div>
                        </section>
                        <AnimationBlock />
                    </main>
                    <footer>
                        <div className="container">
                            <div className="footer_wrapper">
                                <div className="logo"><img src="/images/logo.png" /></div>
                                <div className="wallet">
                                    {props.loading === true ? (
                                        <a
                                            className="opHover"
                                            href="#"
                                            onClick={() => {
                                                setIsOpen(true);
                                            }}
                                        >
                                            <div className="connectButton">
                                                Connect Wallet
                                            </div>                                                                
                                        </a>
                                    ) : (
                                        <Link
                                            className="opHover"
                                            to="/dashboard"
                                        >
                                            <div className="connectButton --active">
                                                Dashboard
                                            </div> 
                                        </Link>
                                    )}
                                </div> 
                            </div>                           
                        </div>
                    </footer>
            </div>
            {isOpen && (
                <ModalConnector
                    visible={isOpen}
                    setVisible={setIsOpen}
                ></ModalConnector>
            )}
        </>
    );
}
